<ui-modal [modalTitle]="title" size="md" [scrollable]="true">
	<ng-container *ngIf="(modal?.isOpen || false) && task">
		<ui-form labelWidth="9rem">
			<ui-form-control *ngIf="task.stage === 'follow_up'" label="Change Task Stage">
				<select class="custom-select w-auto" [(ngModel)]="taskStage" [ngModelOptions]="{ standalone: true }">
					<option [ngValue]="'active'">Active</option>
					<option [ngValue]="'completed'">Completed</option>
				</select>
			</ui-form-control>
		</ui-form>
		<p *ngIf="task.stage === 'follow_up'">Please describe how this task has been resolved. This will be saved as a note.</p>
		<p *ngIf="task.stage !== 'follow_up'">Please describe why this task has been marked as a follow up. This will be saved as a note.</p>
		<textarea rows="5" class="form-control" [placeholder]="placeholder" [(ngModel)]="note" [ngModelOptions]="{ standalone: true }" appDesktopFocus></textarea>
	</ng-container>

	<button type="button" class="btn btn-secondary" (click)="modal.close()" [disabled]="disabled" ui-modal-footer>Cancel</button>
	<button *ngIf="task && task.stage === 'follow_up'" type="submit" class="btn btn-success" (click)="resolveFollowUp()" [disabled]="disabled" ui-modal-footer>Resolve</button>
	<button *ngIf="task && task.stage === 'follow_up' && task.work_order_id" type="button" class="btn btn-primary" (click)="resolveFollowUp(true)" [disabled]="disabled" ui-modal-footer>Resolve & Rebook</button>
	<button *ngIf="task && task.stage !== 'follow_up'" type="submit" class="btn btn-warning" (click)="markFollowUp()" [disabled]="disabled" ui-modal-footer>Mark Follow Up</button>
</ui-modal>
